const TEAM_MANAGER_ROLES = new Set([
  "ysv_admin",
  "league_admin",
  "pro_league_admin",
  "org_admin",
]);

export const canManageTeams = (role) => TEAM_MANAGER_ROLES.has(role);
